import React from 'react'
import { Tooltip } from '@material-ui/core'


export default function AppTooltip({ children, title = "", placement = "top", containerProps, tooltipProps }) {


    return <Tooltip
        title={title}
        placement={placement}
        enterDelay={200}
        leaveDelay={200}
        arrow
        {...tooltipProps}
    >
        <div {...containerProps} >
            {children}
        </div>
    </Tooltip>
}